import formatterMonetaryValue from '@/app/utils/numberUtils';
import { useEffect, useState } from 'react';

export default function useFormattedCurrency(initialValue: number | string | null | undefined) {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (initialValue != null) {
      setValue(formatterMonetaryValue(initialValue));
    }
  }, [initialValue]);

  return { value, setValue };
}
